<template>
	<div class="receipt_info">
		<div class="changead">
			<div class="inputdata">
				<div class="changeadinput">
					<ul>
						<li>
							<span>发票类型：</span>
							<strong v-if="infoData.receipt_type == 1">增值税普通发票</strong>
							<strong v-if="infoData.receipt_type == 2">增值税专用发票</strong>
						</li>
						<li>
							<span>开票类型：</span>
							<strong v-if="infoData.type == 1">个人</strong>
							<strong v-if="infoData.type == 2">公司</strong>
						</li>
						<li><span>金额：</span><strong>{{infoData.total_money}} 元</strong></li>
						<li v-if="infoData.type == 1"><span>发票个人名称：</span><strong>{{infoData.user_name}}</strong></li>
						<li v-if="infoData.type == 1"><span>发票个人身份证号：</span><strong>{{infoData.user_id_number}}</strong></li>
						<li v-if="infoData.type == 1"><span>发票个人电话：</span><strong>{{infoData.user_phone}}</strong></li>
						<li v-if="infoData.type == 2"><span>公司名称：</span><strong>{{infoData.company_name}}</strong></li>
						<li v-if="infoData.type == 2"><span>公司纳税人识别号：</span><strong>{{infoData.pay_taxes_number}}</strong></li>
						<li v-if="infoData.type == 2"><span>公司地址和电话：</span><strong>{{infoData.address_phone}}</strong></li>
						<li v-if="infoData.type == 2"><span>公司开户行和账号：</span><strong>{{infoData.bank_number}}</strong></li>
						<li v-if="infoData.receipt_type == 2" style="width: 43%;float: left;" ><span>营业执照：</span><img :src='infoData.license_pic' alt="点击查看大图" @click="aipImgLic()" ></li>
						<li v-if="infoData.receipt_type == 2" style="width: 45%;float: left;"><span>一般纳税人证明：</span><img :src="infoData.prove_pic" alt="点击查看大图" @click="aipImgPro()"></li>
						<li>
							<span>配送方式：</span>
							<strong v-if="infoData.send_type == 1">自取</strong>
							<strong v-if="infoData.send_type == 2">邮寄</strong>
						</li>
						<li v-if="infoData.send_type == 2"><span>寄送人姓名：</span><strong>{{infoData.send_name}}</strong></li>
						<li><span>寄送地址：</span><strong>{{infoData.send_address}}</strong></li>
						<li v-if="infoData.send_type == 2"><span>寄送人电话：</span><strong>{{infoData.send_phone}}</strong></li>
						<li><span>创建时间：</span><strong>{{infoData.create_time}}</strong></li>
						<li><span>联系人姓名：</span><strong>{{infoData.drawer_name}}</strong></li>
						<li><span>联系人电话：</span><strong>{{infoData.drawer_phone}}</strong></li>
						<li>
							<span>状态：</span>
							<strong v-if="infoData.status == 0">未开</strong>
							<strong v-if="infoData.status == 1">已开</strong>
							<strong v-if="infoData.status == 2">已取</strong>
						</li>
						<!--<li><span>备注：</span><strong>{{infoData.remark}}</strong></li>-->
						<li><span>户号：</span><strong>{{infoData.account}}</strong></li>
						
					</ul>
					<div class="receipt_info_lists">
						<span>开票内容：</span>
						
						<ul class="receipt_month">
							<li v-for="(item,index) in infoData.list" :key="index">
								<span>{{item.time}}</span> ：
								<span>{{item.pay_type}}</span>
								<span>￥{{item.total_money}} 元</span>
							</li>
						</ul>
					</div>
					<el-button type="primary" @click="closeInfo()" class="receipt_close_button">关闭</el-button>
				</div>
				<div class="big_img" v-if="imgBigShow">
					<img src="../assets/close_white.png"  style="width: 25px;height: auto;margin: 0;position: absolute;right:5px;top:5px " @click="closeBigImg"/>
					<div class="big_img_close">
						<img :src='bigImg' alt="点击查看大图" @click="aipImgLic()" >
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'receipt-info',
		props:['infoData'],
		data(){
			return{
				bigImg:'',
				imgBigShow:false,
			}
		},
		methods:{
			closeInfo(){
				this.$emit('closeinfo')
			},
			aipImgLic(){
				console.log('2')
				this.bigImg = this.infoData.license_pic
				this.imgBigShow = true
			},
			aipImgPro(){
				console.log('3')
				this.bigImg = this.infoData.prove_pic
				this.imgBigShow = true
			},
			closeBigImg(){
				this.imgBigShow = false
			},
		},
	}
</script>

<style scoped="scoped">
	.receipt_info{
		width: 100%;
		height: 100%;
		position:absolute;
		background-color: rgba(0,0,0,.7);
		top:0;
		left: 0;
		z-index: 10;
	}
	.changead{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 3;
		width:650px;
		height: 80%;
		background-color: white;
		overflow-x: hidden;
		overflow-y: auto;
		
		border:2px solid #8fceff;
		border-radius: 10px;
		box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	}
	@media  (max-width:1400px ) {
		.changead{
			left: 340px;
			top: 0px;
		}
	}
	.changeadinput{
		width: 570px;
		margin: 0 auto;
		text-align: center;
		padding: 20px 0;
		
	}
	.receiptInfo{
		
	}
	.changeadinput ul{
		list-style: none;
		margin: 0;
		padding: 0;
		overflow: hidden;
	}
	.changeadinput ul li{
		text-align: left;
		overflow: hidden;
		width: 100%;
	}
	.changeadinput ul li span{
		width: 160px;
		display: inline-block;
		text-align: right;
		height: 35px;
		float: left;
		line-height:35px;
		font-size: 14px;
	}
	.changeadinput ul li img{
		width:80px;
		float: left;
		cursor: pointer;
	}
	.changeadinput ul li strong{
		width: 408px;
		/* height: 35px; */
		font-size: 14px;
		float: left;
		line-height: 35px;
		font-weight: 100;
	}
	.receipt_close_button{
		width: 150px;
		border-radius: 20px;
		margin-top: 10px;
	}
	.receipt_month{
	}
	.receipt_info_lists{
		width: 600px;
		overflow: hidden;
		font-size: 14px;
		margin: 0 auto;
	}
	.receipt_info_lists span{
		height: 30px;
		line-height: 30px;
		text-align:right;
		display: block;
		float: left;
		width: 160px;
	}
	.receipt_info_lists ul{
		float: left;
		width: 100%;
	}
	.receipt_info_lists ul li{
		text-align: center;
	}
	.receipt_info_lists ul li span{
		width: auto;
		float: none;
	}
	.big_img{
		background: rgba(0,0,0,.5);
		position: absolute;
	    z-index: 50;
	    color: white;
	    top: 0;
	    width: 100%;
	    text-align: center;
	    height: 100%;
	}
	.big_img_close{
		
	}
	.big_img img{
		width: auto;
		height: 450px;
		margin-top: 100px;
	}
</style>


// WEBPACK FOOTER //
// receiptInfo.vue?26992564